
export default {
  name: 'HButtonOption',
  props: {
    label: {
      type: String,
    },
    value: {
      type: [Array, String, Object, Boolean, Number],
    },
    options: {
      type: Array,
      required: true,
      validator: (value) =>
        value.every((v) => typeof v === 'string' || 'object'),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maximum: {
      type: [Number, String],
      default: 2,
    },
    mandatory: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    groupOptions: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Boolean,
      default: true,
    },
    borderless: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    tile: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    bubbleEvent(e) {
      this.$emit('input', e);
    },
  },
};
